import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';
import BaseCheckoutLayout from './base-checkout-layout';
import Shipment from './delivery/shipment';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import Loader from '../shared/loader';

import styles from '../styles/components/checkout-steps/delivery-form.scss';

import APP_ROUTES from '../../constants/app-routes';
import translations from '../../../translations/app-translations';
import ShipmentsUtils from '../../services/shipments-utils';

class DeliveryForm extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });

        this.handleDeliveryFormSubmit = this.handleDeliveryFormSubmit.bind(this);
    }

    /* Render this step only if order is present and in a valid checkout state. */
    componentWillMount() {
        const { order } = this.props;

        if (!CheckoutStepCalculator.isStepEditable(order.checkout_steps, 'delivery', order.state)) {
            this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
        }

        if (!order.id) {
            this.props.redirectToCart();
        }
    }

    componentDidMount() {
        this.props.setCurrentCheckoutStep();
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    handleDeliveryFormSubmit(formData) {
        window.scrollTo(0, 0);

        return this.props.handleDeliveryFormSubmit(formData, this.props.order, this.props.locale.currentLocale).then(
            () => {
            },
            (error) => {
                const sanitizedErrors = this._sanitizedErrorMessages(error.response.body.errors);
                throw new SubmissionError({ order: sanitizedErrors });
            },
        );
    }

    // eslint-disable-next-line class-methods-use-this
    _sanitizedErrorMessages(errors) {
        const { unflatten } = require('flat');

        const unflattenedErrors = unflatten(errors);

        unflattenedErrors.bill_address_attributes = unflattenedErrors.bill_address;
        unflattenedErrors.ship_address_attributes = unflattenedErrors.ship_address;

        return unflattenedErrors;
    }

    render() {
        const { stores, locale } = this.props;

        const { shipments, line_items: lineItems } = this.props.order;
        const { handleSubmit, valid, submitting } = this.props;

        const storeIdsCount = ShipmentsUtils.countAmountOfStores(shipments);
        let lastStore;
        let cont = 0;

        const shipmentsMarkup = shipments && shipments.length > 0 && shipments.map((shipment, idx) => {
            const store = stores && stores.find((store) => store.id === shipment.attributes.store_ids[0]);

            if (store !== lastStore) {
                lastStore = store;
                cont = 0;
            } else {
                cont += 1;
            }
            return (
                <div
                    key={idx}
                    className={styles.deliveryFormShipments}
                    style={{
                        paddingBottom: ShipmentsUtils.nextIsSameStore(shipments, idx) ? 1 : 25,
                        paddingTop: ShipmentsUtils.prevIsSameStore(shipments, idx) ? 1 : 25,
                        marginBottom: ShipmentsUtils.nextIsSameStore(shipments, idx) ? 0 : 20,
                    }}
                >
                    <Shipment
                        store={store}
                        shipment={shipment}
                        lineItems={lineItems}
                        selected={shipment.selected_shipping_rate}
                        fieldNamePrefix={`order[shipments_attributes][${idx}]`}
                        hideTitle={ShipmentsUtils.prevIsSameStore(shipments, idx)}
                        /* eslint-disable-next-line max-len */
                        details={`${translations[locale.currentLocale]['shipment.word']} ${cont + 1} ${translations[locale.currentLocale]['of.word']} ${storeIdsCount[shipment.attributes.store_ids[0]]}`}
                    />
                </div>
            );
        });

        return (
            <Layout>
                <BaseCheckoutLayout
                    hasExtraTimeCheckout={this.props.hasExtraTimeCheckout}
                    gracePeriod={this.props.gracePeriod}
                    locale={this.props.locale.currentLocale}
                    currentStep="delivery"
                    checkoutSteps={this.props.order.checkout_steps || []}
                    order={this.props.order}
                >
                    {submitting && (
                        <div className="checkout-loading-container">
                            <FormattedMessage id="saving-delivery" defaultMessage="Saving delivery" />
                            <Loader displayLoader size={36} />
                        </div>
                    )}
                    <form onSubmit={handleSubmit(this.handleDeliveryFormSubmit)} style={{ display: submitting ? 'none' : 'inherit' }}>
                        {shipmentsMarkup}
                        <div className="buttons-container">
                            <Link to={APP_ROUTES.checkout.addressPageRoute}>
                                <button
                                    type="button"
                                    className="button--outlined"
                                    style={{ marging: 30 }}
                                >
                                    <FormattedMessage id="back" defaultMessage="Back" />
                                </button>
                            </Link>
                            <button
                                type="submit"
                                className={`button--outlined ${submitting && 'button-disabled'}`}
                                style={{ marging: 30 }}
                                disabled={!valid || submitting}
                            >
                                <FormattedMessage id="continue" defaultMessage="Continue" />
                            </button>
                        </div>
                    </form>
                </BaseCheckoutLayout>
            </Layout>
        );
    }
}

DeliveryForm = reduxForm({
    form: 'deliveryForm',
})(DeliveryForm);

DeliveryForm = connect((state) => {
    const shipments = state.order.shipments || [];
    // eslint-disable-next-line camelcase
    const shipments_attributes = [];

    if (shipments && shipments.length > 0) {
        shipments.sort(ShipmentsUtils.compareShipments);

        shipments.forEach((shipment, idx) => {
            if (shipment.selected_shipping_rate && shipment.selected_shipping_rate.id) {
                shipments_attributes[idx] = { selected_shipping_rate_id: `${shipment.selected_shipping_rate.id}` };
            }
        });
    }

    return {
        initialValues: {
            order: {
                shipments_attributes,
            },
        },
    };
})(DeliveryForm);

export default injectIntl(DeliveryForm);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/delivery-form.jsx
 **/